<template>
	<div class="columna" :style="value.estilos" :class="value.clases">
		<parte v-for="(p, j) in value.partes" :key="`cpnnte-sccn-prte-${j}`" v-model="value.partes[j]"></parte>
	</div>
</template>

<script>

import Parte from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/Parte'

export default {
  name: 'Columna',

  data: () => ({
		//
	}),

	components: {
		Parte,
	},
	
	props: {
		value: {
			type: Object,
			default: function() {
				return { partes: [], clases: {}, estilos: {} }
			}
		}
	},

};

</script>